import { message } from "antd";
import api from "common/api";
import { IUniversities } from "common/types/universities";
import React, {
  FC,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";

const Context = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState<IUniversities>();
  const [loading, setLoading] = useState(false);

  const getById = async (id: string) => {
    try {
      setLoading(true);
      const response = await api.university.getById(id);
      setData(response.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    if (id)
      try {
        const response = await api.university.delete(id);
        message.success("Universitet o'chirildi");
        navigate(-1);
      } catch (err) {
        console.log(err);
      }
    else navigate(-1);
  };

  useEffect(() => {
    if (id) getById(id);
  }, []);
  return {
    state: { data, loading },
    actions: { handleDelete },
  };
};

const UniversitiesInfoContext = createContext<any>({ state: {}, actions: {} });

export const UniversitiesInfoContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <UniversitiesInfoContext.Provider value={value}>
      {children}
    </UniversitiesInfoContext.Provider>
  );
};

export default function useUniversitiesInfoContext() {
  return useContext<ReturnType<typeof Context>>(UniversitiesInfoContext);
}
